module.exports = __webpack_public_path__ + "img/hubbel.2adef12a.png";